import { MenuItem } from "react-aria-components";

import styles from "./menu-list-item.module.css";

interface MenuListItemProps {
  children?: React.ReactNode;
  onAction?: () => void;
  textValue?: string;
  isDisabled?: boolean;
  "data-test-role"?: string;
}

export default function MenuListItem({
  children,
  onAction,
  textValue,
  isDisabled,
  "data-test-role": testRole,
}: MenuListItemProps) {
  const resolvedTextValue =
    textValue || (typeof children === "string" ? children : undefined);

  return (
    <MenuItem
      isDisabled={isDisabled}
      textValue={resolvedTextValue}
      className={styles.menuItem}
      onAction={onAction}
      data-test-role={testRole}
    >
      {children}
    </MenuItem>
  );
}
